import Send from "@mui/icons-material/Send";
import type { FC } from "react";
import { ScheduleButton, type ScheduleButtonProps } from "./schedule-button";

export const ScheduleImmediateButton: FC<Omit<ScheduleButtonProps, "icon" | "title">> = (props) => {
  return <ScheduleButton icon={<Send />} title="Send immediately" {...props} />;
};
